<div class="paid-content-informer">
  <app-icon
    icon="lock"
    class="lock-icon"
    [width]="35"
    [height]="35">
  </app-icon>
  <h2 class="title">{{ 'collections.paid-content-informer.title' | customLocale }}</h2>
  <p class="text">{{ 'collections.paid-content-informer.message' | customLocale }}</p>
  <on-ui-button class="secondary"
                label="collections.paid-content-informer.action"
                (click)="onSelected()">
  </on-ui-button>
</div>
